"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("../../theme/types");
const Box_1 = require("../Box");
const Flex_1 = require("../Flex");
const Component = (0, styled_components_1.default)(Box_1.Box)(({ theme, justify, align, areas, cols, rows, gap }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (theme.GRID || {})), { display: 'grid' }), (justify ? { justifyContent: types_1.propValueMap[justify] || justify } : {})), (align ? { alignItems: types_1.propValueMap[align] || align } : {})), (areas ? { gridTemplateAreas: areas } : {})), (cols ? { gridTemplateColumns: cols } : {})), (rows ? { gridTemplateRows: rows } : {})), (gap ? { gridGap: theme.GAP[gap] } : {}))));
const ItemWrapper = styled_components_1.default.div `
  grid-area: ${({ area }) => area};
`;
const GridComponent = (_a) => {
    var props = __rest(_a, []);
    return (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props), void 0);
};
const Item = (_a) => {
    var { as } = _a, itemProps = __rest(_a, ["as"]);
    const TargetComponent = {
        Box: Box_1.Box,
        Flex: Flex_1.Flex,
        Grid: GridComponent,
    }[as];
    return (0, jsx_runtime_1.jsx)(ItemWrapper, Object.assign({ as: TargetComponent }, itemProps), void 0);
};
exports.Grid = Object.assign(GridComponent, {
    Item,
});
//# sourceMappingURL=Grid.js.map